/**
 * NumberedSteps.tsx — nummererte steg ved siden av en illustrasjon
 *
 * ibm.com «product demo teaser» (watsonx Orchestrate): seksjonsinnledning,
 * deretter en nummerert liste til venstre og illustrasjon til høyre.
 * Listen er en <ol>, så rekkefølgen leses opp riktig av skjermlesere.
 */

import type { ReactNode } from 'react';
import type { ProductSteps } from '@/types/product';
import SectionHeader from './SectionHeader';
import styles from './product.module.css';

interface NumberedStepsProps {
  id: string;
  steps: ProductSteps;
  art: ReactNode;
}

export default function NumberedSteps({ id, steps, art }: NumberedStepsProps) {
  return (
    <section id={id} className={styles.sectionAlt} aria-labelledby={`${id}-heading`}>
      <div className={styles.container}>
        <SectionHeader id={`${id}-heading`} eyebrow={steps.eyebrow} heading={steps.heading}>
          <p className={styles.lead}>{steps.intro}</p>
        </SectionHeader>

        <div className={styles.split}>
          <ol className={styles.steps}>
            {steps.items.map((step) => (
              <li key={step.title} className={styles.step}>
                <div>
                  <h3 className={styles.stepTitle}>{step.title}</h3>
                  <p className={styles.stepBody}>{step.body}</p>
                </div>
              </li>
            ))}
          </ol>

          <div className={styles.art}>{art}</div>
        </div>
      </div>
    </section>
  );
}
